export enum MidpointRoundingType {
  AwayFromZero = 1,
  ToEven = 2,
}
